<div class="cookie-content p-4">
  <div class="row align-items-center">
    <div class="col-12 col-md-9">
      <h3 class="mb-2">This website uses cookies</h3>
      <div class="d-flex">
        <p>We use cookies to offer you the best experience of our website. Learn about how we use cookies by reading our</p>
        <a href="https://home.kpmg/sg/en/home/misc/privacy.html" target="_blank" class="pl-1">Privacy Policy</a>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <button type="button" (click)="acceptCookies()" class="primary-button">Accept Cookies</button>
    </div>
  </div>
</div>
